export const FETCH_VISIT_SUMMARY_SUCCESS = 'FETCH_VISIT_SUMMARY_SUCCESS';
export const FETCH_VISIT_SUMMARY_FAIL ='FETCH_VISIT_SUMMARY_FAIL';
export const FETCH_VISIT_SUMMARY_START = 'FETCH_VISIT_SUMMARY_START';
